import { LuSparkles } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const servicesNav: NavItem[] = [
  {
    icon: LuSparkles,
    label: 'Servicios',
    hint: 'Catálogo, precios y duraciones',
    to: '/servicios',
    placement: 'more',
  },
];
